import React, { useState, useEffect, useRef } from "react";
import "./Navbar.scss";
// import Logo from "../../../assets/logo-atlyon-white.png";

const Navbar = () => {
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
    const [isAutoScrolling, setIsAutoScrolling] = useState(false);

    const navbarRef = useRef(null);

    useEffect(() => {
        let lastScroll = 0;

        const handleScroll = () => {
            if (isAutoScrolling || !navbarRef.current) return;

            const currentScroll = window.pageYOffset;

            if (currentScroll > 50) {
                if (
                    currentScroll > lastScroll &&
                    !navbarRef.current.classList.contains("scroll-down")
                ) {
                    navbarRef.current.classList.remove("scroll-up");
                    navbarRef.current.classList.add("scroll-down");
                } else if (
                    currentScroll < lastScroll &&
                    navbarRef.current.classList.contains("scroll-down")
                ) {
                    navbarRef.current.classList.remove("scroll-down");
                    navbarRef.current.classList.add("scroll-up");
                }
            } else {
                navbarRef.current.classList.remove("scroll-up", "scroll-down");
            }
            lastScroll = currentScroll;
        };

        const handleClickOutside = (e) => {
            if (
                navbarRef.current &&
                !navbarRef.current.contains(e.target) &&
                isMobileMenuOpen
            ) {
                setIsMobileMenuOpen(false);
                document.body.classList.remove("menu-open");
            }
        };

        const handleResize = () => {
            if (window.innerWidth > 992 && isMobileMenuOpen) {
                setIsMobileMenuOpen(false);
                document.body.classList.remove("menu-open");
            }
        };

        document.addEventListener("click", handleClickOutside);
        window.addEventListener("scroll", handleScroll);
        window.addEventListener("resize", handleResize);

        return () => {
            document.removeEventListener("click", handleClickOutside);
            window.removeEventListener("scroll", handleScroll);
            window.removeEventListener("resize", handleResize);
        };
    }, [isMobileMenuOpen, isAutoScrolling]);

    const scrollToSection = (sectionId) => {
        const element = document.getElementById(sectionId);
        if (element) {
            setIsAutoScrolling(true);
            element.scrollIntoView({ behavior: "smooth" });

            setTimeout(() => {
                setIsAutoScrolling(false);
                if (navbarRef.current) {
                    navbarRef.current.classList.remove("scroll-down");
                    navbarRef.current.classList.add("scroll-up");
                }
            }, 500);
        }
        if (isMobileMenuOpen) {
            setIsMobileMenuOpen(false);
            document.body.classList.remove("menu-open");
        }
    };

    const toggleMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
        document.body.classList.toggle("menu-open", !isMobileMenuOpen);
    };

    const navLinks = [
        { text: "Inicio", section: "home" },
        { text: "¿Cómo funciona?", section: "how-it-works" },
        { text: "Empezar proyecto", section: "email-capture" },
        { text: "FAQ", section: "faq" },
        { text: "Contacto", section: "contact" },
    ];

    return (
        <header id="navbar" ref={navbarRef}>
            <nav className="navbar">
                {/* <div className="navbar__logo">
                    <a
                        href="#home"
                        onClick={(e) => {
                            e.preventDefault();
                            scrollToSection("home");
                        }}
                    >
                        <img
                            src={Logo}
                            alt="Atlyon Logo"
                            className="navbar__logo__image"
                        />
                    </a>
                </div> */}
                <div className="navbar__logo">
                    <a
                        href="#home"
                        onClick={(e) => {
                            e.preventDefault();
                            scrollToSection("home");
                        }}
                    >
                        <span className="navbar__logo__text">
                            Nube de puntos
                        </span>
                    </a>
                </div>

                <div className="navbar__right">
                    <ul className="navbar__links">
                        {navLinks.map((link, index) => (
                            <li key={index} className="navbar__link">
                                <button
                                    className="navbar__links__item"
                                    onClick={() =>
                                        scrollToSection(link.section)
                                    }
                                >
                                    {link.text}
                                </button>
                            </li>
                        ))}
                    </ul>

                    <button
                        className={`navbar__mobile-toggle ${
                            isMobileMenuOpen
                                ? "navbar__mobile-toggle--open"
                                : ""
                        }`}
                        aria-label="Abrir menú"
                        onClick={toggleMobileMenu}
                    >
                        <span className="navbar__mobile-toggle__line"></span>
                        <span className="navbar__mobile-toggle__line"></span>
                        <span className="navbar__mobile-toggle__line"></span>
                    </button>
                </div>

                <div
                    className={`navbar__mobile-menu ${
                        isMobileMenuOpen ? "navbar__mobile-menu--open" : ""
                    }`}
                >
                    <div className="navbar__mobile-menu__content">
                        {navLinks.map((link, index) => (
                            <button
                                key={index}
                                className="navbar__mobile-link"
                                onClick={() => scrollToSection(link.section)}
                            >
                                {link.text}
                            </button>
                        ))}
                    </div>
                </div>
            </nav>
        </header>
    );
};

export default Navbar;
